module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_WoodMatted.ccd5c2bf.jpg";